import { APIService } from "../../../../network/api/APIService";

export const FileData = async ({ method = "GET", id = null, formData = null }) => {
    let endpoint = "/file/";
    let query = {};


    if (id) {
        query.id = id;
    }

    const config = {
        endpoint,
        method,
        data: method === "POST" ? formData : null,
        query: Object.keys(query).length ? query : null,
    };

    return await APIService(config);
};